(function () {
  "use strict";

  var MQ = "(max-width: 749px)";

  function isMobile() {
    try { return window.matchMedia(MQ).matches; }
    catch (error) { return window.innerWidth <= 749; }
  }

  function enhanceSpecs(scope) {
    if (!isMobile()) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var sections = root.querySelectorAll("body.template-product .km-specs");

    sections.forEach(function (section) {
      if (section.getAttribute("data-km-mobile-specs") === "1") return;

      var grid = section.querySelector(".km-spec-grid");
      if (!grid) return;

      var note = section.querySelector(".km-spec-note");
      var details = document.createElement("details");
      var summary = document.createElement("summary");

      details.className = "km-mobile-spec-details";
      summary.textContent = "Voir toutes les caractéristiques";
      details.appendChild(summary);

      grid.parentNode.insertBefore(details, grid);
      details.appendChild(grid);
      if (note) details.appendChild(note);

      section.setAttribute("data-km-mobile-specs", "1");
    });
  }

  function run() { enhanceSpecs(document); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", function (event) {
    enhanceSpecs(event.target || document);
  });
})();
